import { ArgsType, Field, Int } from '@nestjs/graphql'

@ArgsType()
export class UpdateClaimDto {
  @Field(t => Int)
  claimId!: number

  @Field(t => Int)
  state!: number
}
